import React, { useMemo } from 'react';
import { Dialog, DialogTitle, IconButton, List, ListItem, ListItemText, ListSubheader } from '@mui/material';
import { actions } from 'pages/Chart/Chart.redux';
import { Close } from '@mui/icons-material';
import clsx from 'clsx';
import symbolHandlerSx from './SymbolHandler.styles';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';

const width = 300;

const SymbolMultipleChoice = ({ handlerConf, point, symbolID }) => {
    const theme = useTheme(),
        sx = symbolHandlerSx(theme),
        dispatch = useDispatch();

    // compute dynamic position for the dialog (replaces makeStyles)
    const windowWidth = typeof window !== 'undefined' ? window.innerWidth : 0;
    const windowHeight = typeof window !== 'undefined' ? window.innerHeight : 0;
    const left = (point?.[0] ?? 0) + width + 72 > windowWidth ? windowWidth - 72 - width : (point?.[0] ?? 0) - 200;
    const top = (point?.[1] ?? 0) + 700 > windowHeight ? windowHeight - 800 : (point?.[1] ?? 0) - 50;
    const positionStyle = { position: 'fixed', display: 'block', opacity: 1, zIndex: 100, left, top },
        symbols = useSelector((state) => state.chart.symbols),
        symbolsByID = useMemo(
            () =>
                symbols?.reduce((accumulator, current) => {
                    accumulator[current.symbol_id] = current;
                    return accumulator;
                }, {}),
            [symbols]
        ),
        canvas = useSelector((state) => state.chart.symbolOptions.canvas),
        symbol = symbols.find((row) => row.symbol_id === symbolID);

    return (
        <Dialog
            open={true}
            onClose={() => dispatch(actions.resetSymbolOptions({ symbol: symbolID }))}
            BackdropProps={{ invisible: true }}
            PaperProps={{ elevation: 12, style: positionStyle }}
        >
            <DialogTitle>
                {symbol.symbol_name}
                <IconButton
                    sx={sx.closeButton}
                    onClick={() => dispatch(actions.resetSymbolOptions({ symbol: symbolID }))}
                    size="large"
                >
                    <Close />
                </IconButton>
            </DialogTitle>

            <Box style={{ height: '100%' }}>
                <Box sx={{ ...sx.contentContainer, ...sx.symbolContainer }}>
                    {handlerConf.options.map((option, index) => {
                        return (
                            <List key={index} subheader={<ListSubheader component="div">{option.label}</ListSubheader>}>
                                {option.codes
                                    .filter((symbolId) => symbolsByID[symbolId] !== undefined)
                                    .map((symbolID) => {
                                        const sym = symbolsByID[symbolID];

                                        return (
                                            <ListItem
                                                key={sym.symbol_id}
                                                button
                                                onClick={() =>
                                                    dispatch(actions.handleSymbolDispatch(sym.symbol_id, canvas))
                                                }
                                            >
                                                <ListItemText
                                                    primary={sym.symbol_abbreviation}
                                                    secondary={sym.symbol_name}
                                                />
                                            </ListItem>
                                        );
                                    })}
                            </List>
                        );
                    })}
                </Box>
            </Box>
        </Dialog>
    );
};

export default SymbolMultipleChoice;
